// 店舗ページ用JavaScript
document.addEventListener('DOMContentLoaded', function() {
  smoothScroll();
});

function smoothScroll() {
  const targets = document.querySelectorAll('.anker-list a[href^="#"]');
  
  if (targets.length === 0) {
    return;
  }

  targets.forEach(target => {
    target.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      
      const href = target.getAttribute('href');
      // href属性を一時的に削除してブラウザのデフォルト動作を完全に防ぐ
      target.removeAttribute('href');
      
      const scrollTarget = document.querySelector(href === '#' || href === '' ? 'html' : href);
      
      if (scrollTarget) {
        // ヘッダー高さとpadding-topを考慮したオフセット計算
        const headerHeight = 64; // ヘッダーの高さ
        const desiredPadding = window.innerWidth >= 768 ? 160 : 80; // PC: 160px, SP: 80px
        const totalOffset = headerHeight + desiredPadding;
        
        // スムーススクロールで移動
        const scrollPosition = scrollTarget.offsetTop - totalOffset;
        
        window.scrollTo({
          top: scrollPosition,
          behavior: "smooth"
        });
        
        // href属性を復元（スクロール完了後）
        setTimeout(() => {
          target.setAttribute('href', href);
        }, 500);
      }
    });
  });
}